import { Routes, Route } from "react-router-dom"

import "./App.css"

import Site2025 from "./pages/Site2025"
import Site2026 from "./pages/Site2026"
import Notes from "./pages/Notes"
import Create from "./pages/Create"
import Note from "./pages/Note"

function App() {
  return (
    <Routes>
      <Route path="/notes/new" element={<Create />} />
      <Route path="/notes/:at" element={<Note />} />
      <Route path="/notes" element={<Notes />} />
      <Route path="/2025" element={<Site2025 />} />
      <Route path="/" element={<Site2026 />} />
    </Routes>
  );
}

export default App;
